var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from "react";
import PageHeader from "../../components/PageHeader";
import { Post } from "../../components/Post";
import icons from "../../utils/Icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "../../components/Spinner";
import PostLikesModal from "../../components/modals/PostLikesModal";
import PostCommentsModal from "../../components/modals/PostCommentsModal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
var Social = function () {
    var navigate = useNavigate();
    var _a = useState([]), posts = _a[0], setPosts = _a[1];
    var _b = useState(false), postLoading = _b[0], setPostLoading = _b[1];
    var _c = useState(false), listRefresh = _c[0], setListRefresh = _c[1];
    var _d = useState(1), currentPage = _d[0], setCurrentPage = _d[1];
    var _e = useState(true), hasMorePosts = _e[0], setHasMorePosts = _e[1];
    var _f = useState({
        id: null,
        image_id: null,
        likes_count: null,
        caption: "",
        created_at: "",
        comments_count: null,
        image: {},
        users: {},
        likes: [],
    }), currentPost = _f[0], setCurrentPost = _f[1];
    var _g = useState(false), showLikesModal = _g[0], setShowLikesModal = _g[1];
    var _h = useState(false), showCommentsModal = _h[0], setShowCommentsModal = _h[1];
    var userId = useSelector(function (state) { return state.user.userId; });
    var scrollContainerRef = useRef(null);
    var savedScrollPosition = useRef(0);
    var observer = useRef(null);
    var lastPostElementRef = useCallback(function (node) {
        if (postLoading)
            return;
        if (observer.current)
            observer.current.disconnect();
        observer.current = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting && hasMorePosts) {
                getPosts(currentPage);
            }
        });
        if (node)
            observer.current.observe(node);
    }, [postLoading, currentPage, hasMorePosts]);
    useEffect(function () {
        var idleTimeout;
        var resetIdleTimer = function () {
            clearTimeout(idleTimeout);
            idleTimeout = setTimeout(function () {
                setListRefresh(true);
            }, 5 * 60 * 1000); // 5 minutes
        };
        var handleUserActivity = function () {
            resetIdleTimer();
        };
        window.addEventListener("mousemove", handleUserActivity);
        window.addEventListener("keydown", handleUserActivity);
        window.addEventListener("scroll", handleUserActivity);
        resetIdleTimer();
        return function () {
            clearTimeout(idleTimeout);
            window.removeEventListener("mousemove", handleUserActivity);
            window.removeEventListener("keydown", handleUserActivity);
            window.removeEventListener("scroll", handleUserActivity);
        };
    }, []);
    // const posts: PostType[] = [
    // ];
    useEffect(function () {
        getPosts(1);
    }, []);
    useEffect(function () {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = savedScrollPosition.current;
        }
    }, [posts]);
    useEffect(function () {
        if (listRefresh) {
            setPosts([]);
            setCurrentPage(1);
            getPosts(1);
        }
    }, [listRefresh]);
    var getPosts = function (page) {
        if (scrollContainerRef.current) {
            savedScrollPosition.current = scrollContainerRef.current.scrollTop;
        }
        setPostLoading(true);
        axios
            .get("posts?page=" + page)
            .then(function (response) {
            // setPosts(response.data.data);
            var _a = response.data, data = _a.data, next_page_url = _a.next_page_url;
            if (page === 1) {
                setPosts(data);
            }
            else {
                setPosts(function (prev) { return __spreadArray(__spreadArray([], prev, true), data, true); });
            }
            setHasMorePosts(!!next_page_url);
            setCurrentPage(page + 1);
        })
            .catch(function (error) {
            console.error("Error fetching posts:", error);
        })
            .finally(function () {
            setPostLoading(false);
        });
    };
    var handlePageChange = function (path) {
        navigate(path);
    };
    var updateLikeHandle = function (index, post) {
        var prevPosts = __spreadArray([], posts, true);
        prevPosts[index] = post;
        setPosts(prevPosts);
    };
    var openLikesModalHandle = function (post) {
        setCurrentPost(post);
        setShowLikesModal(true);
    };
    var openCommentsModalHandle = function (post) {
        setCurrentPost(post);
        setShowCommentsModal(true);
    };
    var updatePostHandle = function (post) {
        var index = posts.findIndex(function (single_post) {
            return single_post.id === post.id;
        });
        console.log(index, "index");
        if (index != -1) {
            var newPosts = __spreadArray([], posts, true);
            newPosts[index] = post;
            setPosts(newPosts);
        }
    };
    var deletePostHandle = function (post_id) {
        axios
            .post("posts/delete", {
            post_id: post_id,
            user_id: userId,
        })
            .then(function (response) {
            var _a;
            toast.success("Post deleted successfully");
            setPosts(posts.filter(function (post) { return post.id !== post_id; }));
            (_a = scrollContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
        })
            .catch(function (error) {
            toast.error(error.message);
            console.log(error);
        });
    };
    return (_jsxs("div", { children: [_jsx(PageHeader, { pageTitle: "Social" }), _jsx("div", { ref: scrollContainerRef, className: "flex-1  overflow-y-auto custom-content-height pb-5", children: _jsxs("div", { className: "flex justify-between items-center px-5 py-3 w-full bg-white border-b border-gray-200 min-h-[52px]", children: [_jsxs("div", { className: "flex flex-col w-full mb-5", children: [posts.map(function (post, index) { return (_jsxs(React.Fragment, { children: [_jsx(Post, { post: post, updateLikes: function (post) {
                                                return updateLikeHandle(index, post);
                                            }, openLikesModal: openLikesModalHandle, openCommentsModal: openCommentsModalHandle, deletePost: deletePostHandle }), index < posts.length - 1 && (_jsx("div", { className: "mt-5 w-full border border-gray-200 border-solid min-h-[1px]" })), index === posts.length - 1 && (_jsx("div", { ref: lastPostElementRef, className: "h-1" }))] }, index)); }), postLoading && hasMorePosts && (_jsx("div", { className: "p-4 text-center", children: _jsx(Spinner, {}) }))] }), _jsxs("button", { onClick: function () { return handlePageChange("/#/create-post"); }, className: "absolute bottom-28 right-6 flex z-10 gap-0.5 items-center self-end py-2.5 pr-4 pl-2.5 mt-0 text-base tracking-normal text-right text-white whitespace-nowrap bg-blue-400 rounded-[50px] shadow-[0px_1px_3px_rgba(47,43,67,0.1)]", children: [_jsx("img", { loading: "lazy", src: icons.plus, alt: "", className: "object-contain shrink-0 self-stretch my-auto w-6 aspect-square" }), _jsx("div", { className: "self-stretch my-auto", children: "New" })] })] }) }), showLikesModal && (_jsx(PostLikesModal, { post: currentPost, closeModal: function () { return setShowLikesModal(false); } })), showCommentsModal && (_jsx(PostCommentsModal, { post: currentPost, closeModal: function () { return setShowCommentsModal(false); }, updatePost: updatePostHandle }))] }));
};
export default Social;
